















import { defineComponent } from "@vue/composition-api";

interface Props {
  selected: string;
  values: string[];
}

export default defineComponent<Props>({
  name: "NameInput",
  props: {
    selected: { type: String, required: true },
    values: { type: Array, required: true }
  },
  model: {
    event: "select",
    prop: "selected"
  }
});
